import { render } from "./agent.index.vue?vue&type=template&id=0b81e7e0"
import script from "./agent.index.vue?vue&type=script&lang=js"
export * from "./agent.index.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__